import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LoadingWrapper = styled(Grid)`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;